<template>

<app-input-wrapper :stacked="true" :value="value" :note="note" :label="label" :errored="errored" class="gallery" :class="{'is-errored': errored, 'is-previewing': select}">

	<app-input-select :placeholder="placeholder" v-model="select" :options="selectOptions" />

	<div class="gallery-preview" v-if="select"><img :src="previewImage" /></div>
        
</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

    mixins: [mixinInput],
    
    props: ['options'],

    data: function() {

        return {
            select: 0
        }
            
    },
    
    watch: {

        value: function(n) {

            this.select = n

        },
        
        select: function(n) {

            this.onValueChange(parseInt(n))

        }

    },
    
    created: function() {

        this.select = this.value

    },

    computed: {

        previewImage: function() {

            return (this.select) ? this.$_.findWhere(this.options, {
                id: parseInt(this.select)
            }).image : false

        },

        selectOptions: function() {

            var options = {}

            this.$_.each(this.options, function(option) {

                options[option.id] = option.name

            })

            return options

        }

    }

}

</script>

<style scoped>

.gallery.is-previewing >>> .input-value {
    border-radius: 4px 4px 0px 0px;
}

.gallery.is-previewing >>> .input {
    margin-bottom: 0px;
}

.gallery-preview {
	border: 1px solid var(--color-grey-light);
	border-top-width: 0px;
	border-radius: 0px 0px 4px 4px;
	max-height: 200px;
	padding: 10px;
}

.gallery-preview img {
	width: auto;
	max-width: 100%;
	max-height: 178px;
}

</style>